module.exports = __webpack_public_path__ + "img/yg@2x.72770898.png";